import { useEffect, useState } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { photoUrl } from "../../lib/api";

export const Lightbox = ({ photos = [], start = 0, onClose, onChange }) => {
  const [i, setI] = useState(start);
  const n = photos.length;

  useEffect(() => {
    onChange?.(i);
  }, [i, onChange]);

  useEffect(() => {
    window.__lenis?.stop();
    document.body.style.overflow = "hidden";
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") setI((v) => (v + 1) % n);
      if (e.key === "ArrowLeft") setI((v) => (v - 1 + n) % n);
    };
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
      window.__lenis?.start();
    };
  }, [n, onClose]);

  return (
    <div className="fixed inset-0 z-[100] flex flex-col bg-ink/95 backdrop-blur-md" data-testid="lightbox">
      <div className="flex items-center justify-between px-5 py-4 text-pearl">
        <span className="font-mono text-xs tracking-[0.24em]">{i + 1} / {n}</span>
        <button onClick={onClose} className="rounded-full border border-white/20 p-2.5 hover:bg-white/10" data-testid="lightbox-close" aria-label="close"><X className="h-5 w-5" /></button>
      </div>
      <div className="relative flex flex-1 items-center justify-center px-4 pb-8">
        <img src={photoUrl(photos[i])} alt="" className="max-h-full max-w-full rounded-xl object-contain" data-testid="lightbox-image" />
        {n > 1 && (
          <>
            <button onClick={() => setI((i - 1 + n) % n)} className="gallery-btn left-4" data-testid="lightbox-prev" aria-label="prev"><ChevronLeft className="h-5 w-5" /></button>
            <button onClick={() => setI((i + 1) % n)} className="gallery-btn right-4" data-testid="lightbox-next" aria-label="next"><ChevronRight className="h-5 w-5" /></button>
          </>
        )}
      </div>
    </div>
  );
};
